export const dateFormatterFB = (date) => {
    const datePost = date.toDate()
    const dateFormatted = `${datePost.getDate()}/${
        datePost.getMonth() + 1
    }/${datePost.getFullYear()}`
    return dateFormatted
}

export const dateFormatterFootballApi = (date = new Date()) => {
    /* if (localStorage.getItem("date_selected")) {
        return localStorage.getItem("date_selected")
    } */
    const today = date
    let day = today.getDate(),
        month = today.getMonth() + 1
    month = today.getMonth() + 1
    if (month < 10) {
        month = `0${month}`
    } else {
        month = month
    }
    if (today.getDate() < 10) {
        day = `0${today.getDate()}`
    } else {
        day = today.getDate()
    }
    const todayFormattedUTC = `${today.getFullYear()}-${month}-${day}`
    return todayFormattedUTC
}

export const dateFormatter = (date) => {
    const datePost = new Date(date)
    const dateFormatted = `${datePost.getDate()}/${
        datePost.getMonth() + 1
    }/${datePost.getFullYear()}`
    return dateFormatted
}

export function dateFormatterAddZero(date) {
    let dateToReturn
    if (date < 10) {
        dateToReturn = `0${date}`
    } else {
        dateToReturn = date
    }
    return dateToReturn
}

export const dateInputFormatterDateTimeLocal = (date) => {
    const defaultDate = '2021-01-26T16:52'
    let dateObj = new Date(date)

    if (!dateObj) {
        dateObj = new Date()
    }

    const year = dateObj.getFullYear()
    const month = dateFormatterAddZero(dateObj.getMonth() + 1)
    const day = dateFormatterAddZero(dateObj.getDate())
    const hours = dateFormatterAddZero(dateObj.getHours())
    const minutes = dateFormatterAddZero(dateObj.getMinutes())

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`
    return formattedDate
}

export const dateInputFormatterShort = (date) => {
    let dateObj = new Date(date)

    if (!dateObj) {
        dateObj = new Date()
    }

    const year = dateObj.getFullYear()
    const month = dateFormatterAddZero(dateObj.getMonth() + 1)
    const day = dateFormatterAddZero(dateObj.getDate())
    const hours = dateFormatterAddZero(dateObj.getHours())
    const minutes = dateFormatterAddZero(dateObj.getMinutes())

    const formattedDate = `${year}-${month}-${day}`
    return formattedDate
}

export const dateFormatterShort = (date) => {
    const datePost = new Date(date)
    const dateFormatted = `${datePost.getDate()}/${datePost.getMonth() + 1}`
    return dateFormatted
}

export const dateInputFormatter = (date) => {
    const datePost = new Date(date)

    let dayPost, monthPost

    if (datePost.getDate() < 10) {
        dayPost = `0${datePost.getDate()}`
        dayPost = +dayPost
    }

    const dateFormatted = `${datePost.getFullYear()}-${
        datePost.getMonth() + 1
    }-${dayPost}`
    return dateFormatted
}
export const dateInputFormatterFB = (date) => {
    const datePost = date.toDate()
    let dayPost, monthPost

    console.log(datePost.getDate() < 10)
    if (datePost.getDate() < 10) {
        dayPost = `0${datePost.getDate()}`
    } else {
        dayPost = datePost.getDate()
    }

    if (datePost.getMonth() + 1 < 10) {
        monthPost = `0${datePost.getMonth() + 1}`
    } else {
        monthPost = datePost.getMonth() + 1
    }

    const dateFormatted = `${datePost.getFullYear()}-${monthPost}-${dayPost}`
    return dateFormatted
}

export const timeFormatter = (date) => {
    let minutes = date.getMinutes()
    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()

    if (day < 10) {
        day = `0${day}`
    } else {
        day = day
    }
    if (month < 10) {
        month = `0${month}`
    } else {
        month = month
    }
    if (minutes < 10) {
        minutes = `0${minutes}`
    }
    const timeFormatted = date.getHours() + ':' + minutes

    return timeFormatted
}

export const isToday = (date) => {
    const today = new Date()
    const dateToCompare = new Date(date)

    const todaysDate = today.getDate()
    const todaysMonth = today.getMonth()
    const todaysYear = today.getFullYear()

    if (
        dateToCompare.getDate() === todaysDate &&
        dateToCompare.getMonth() === todaysMonth &&
        dateToCompare.getFullYear() === todaysYear
    ) {
        return true
    } else {
        return false
    }
}

export const compareDates = (date, dateToCompare) => {
    const initialDateObj = new Date(date)
    const dateToCompareObj = new Date(dateToCompare)

    const todaysDate = initialDateObj.getDate()
    const todaysMonth = initialDateObj.getMonth()
    const todaysYear = initialDateObj.getFullYear()

    if (
        dateToCompareObj.getDate() === todaysDate &&
        dateToCompareObj.getMonth() === todaysMonth &&
        dateToCompareObj.getFullYear() === todaysYear
    ) {
        return true
    } else {
        return false
    }
}
